import React from 'react';
import Box from "@mui/material/Box";
import {Link as LinkUI, useNavigate } from "react-router-dom";
import { useSelector} from "react-redux";
import {Avatar, Button, Container, Grid, Paper, Stack, Typography} from "@mui/material";
import {ErrorContainer} from "../../../../Components";
import { styled } from "@mui/material/styles";

const Link = styled(LinkUI)(({ theme }) => ({
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontSize: '1.2rem',
    '&:hover': {
        cursor: 'pointer',
        color: theme.palette.primary.dark,
    },
}));

export const Error404 = () => {
    const navigate = useNavigate();
    const tenant = useSelector(store => store.app.tenant);

    return (
        <Box width="100%" minHeight="100vh" display="flex" alignItems="center" justifyContent="center">
            <ErrorContainer maxWidth="md" component="section">
                <Container>
                    <Paper sx={{ p: 4 }}>
                        <Grid container spacing={4} alignItems="center">
                            <Grid item xs={12} textAlign="center">
                                <Link to="/">
                                    <Avatar
                                        variant="square"
                                        src={tenant?.avatar_url || '/images/favicon/adnec-favicon-color.png'}
                                        sx={{ height: 60, width: 60, mx: 'auto', mb: 2 }}
                                        alt="Logo"
                                    />
                                </Link>
                                <Typography variant="h3" gutterBottom>
                                    404 - Page Not Found
                                </Typography>
                                <Typography variant="body1" color="text.secondary">
                                    The page you are looking for doesn't exist or was moved.
                                </Typography>
                                <Stack spacing={2} direction="row" justifyContent="center" mt={4}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Go Back
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => navigate('/')}
                                    >
                                        Go to Dashboard
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Paper>
                </Container>
            </ErrorContainer>
        </Box>
    );
};
